module.exports = __webpack_public_path__ + "static/img/tai-sui-jin.2d4cb16.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/tai-sui-jin.jpeg
// module id = 6G0X
// module chunks = 1